<template>
  <v-card>
    <v-card-title class="text-h6 mb-3">
      <!-- {{ returnType == "recovery" ? $t("Thu hồi") : $t("Lấy về") }} -->
      {{ order.tracking_id }}
    </v-card-title>

    <v-card-text>
      <v-row class="fs-12" no-gutters>
        <v-col cols="4" class="text-right font-weight-medium black--text">
          Khách hàng: &nbsp;
        </v-col>
        <v-col cols="8">
          {{ order.name }}
        </v-col>

        <v-col cols="4" class="text-right font-weight-medium black--text">
          Quốc tịch: &nbsp;
        </v-col>
        <v-col cols="8">{{ order.country_name }}</v-col>

        <v-col cols="12">
          <v-simple-table class="table-padding-2 table-h-36 mt-3">
            <template v-slot:default>
              <thead class="v-data-table-header">
                <tr>
                  <th
                    role="columnheader"
                    class="text-center"
                    style="width: 50px; min-width: 50px"
                  >
                    Mã
                  </th>
                  <th
                    role="columnheader"
                    class="text-center"
                    style="width: 75px"
                  >
                    Loại tài sản
                  </th>
                  <th role="columnheader" class="text-center">Tài sản</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in order.items"
                  :key="`i_${index}_${item.id}`"
                  class="text-center"
                >
                  <td style="width: 50px; min-width: 50px">
                    {{ item.name }}
                  </td>
                  <td>{{ item.asset_type_name }}</td>
                  <td>{{ item.asset_name }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-row>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="red darken-1" text @click="hideConfirmDialog">
        {{ $t("Hủy") }}
      </v-btn>
      <v-btn color="green darken-1" text @click="createCommand">
        {{ $t("Xác nhận") }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { httpClient } from "@/libs/http";

export default {
  name: "CreateReturnRequest",
  props: {
    order: {
      type: Object,
      default: () => {},
    },
    returnType: {
      type: String,
      default: () => "return",
    },
  },
  data: () => ({
    isLoading: false,
  }),
  computed: {},
  mounted() {},
  methods: {
    hideConfirmDialog() {
      this.$emit("close", true);
    },
    async createCommand() {
      if (this.isLoading) {
        this.$vToastify.warning(this.$t("Loading"));
        return false;
      }

      this.isLoading = true;

      try {
        await httpClient.post("/order/v1/delivery-request-create-command", {
          id_order: this.order.id,
          type: this.returnType,
        });
        this.isLoading = false;
        this.hideConfirmDialog();
      } catch (e) {
        const errMsg =
          (e.response &&
            e.response.data &&
            e.response.data.error &&
            e.response.data.error.message) ||
          null;
        this.$vToastify.error(errMsg);
        this.isLoading = false;
      }
    },
  },
};
</script>
